import { gql } from "@apollo/client";

export const DELETE_PROGRAMMING_STRUCTURE = gql`
  mutation deleteProgrammingStructure(
    $scenarioId: ID!
    $originId: ID
    $input: ProgrammingStructureCrudInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      programmingStructuresCrud(input: $input) {
        userCanSkipValidations
        skippedValidations
        commited
        payload {
          deletes {
            structure {
              id
            }
            validationErrors {
              __typename
            }
          }
        }
      }
    }
  }
`;
